import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useGlobalPref } from '../../hooks/useGlobalPref';
import { availableLanguages, setI18NextLanguage } from '../../i18n';
import { Link } from '../common/Link';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Text } from '../common/Text';

import { Setting } from './UI';

export function LanguageSettings() {
  const { t } = useTranslation();
  const [language, setLanguage] = useGlobalPref('language');
  const isEnabled = !!availableLanguages.length;

  return (
    <Setting
      primaryAction={
        <Select
          value={isEnabled ? (language || 'system-default') : 'not-available'}
          onValueChange={value => {
            const lang = value === 'system-default' ? '' : value;
            setLanguage(lang);
            setI18NextLanguage(lang);
          }}
          disabled={!isEnabled}
        >
          <SelectTrigger className="w-[200px]" aria-label={t('Select language')}>
            <SelectValue
              placeholder={
                isEnabled ? t('Select language') : t('No languages available')
              }
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="system-default">{t('System default')}</SelectItem>
            <SelectSeparator />
            {availableLanguages.map(lang => (
              <SelectItem key={lang} value={lang}>
                {new Intl.DisplayNames([lang], { type: 'language' }).of(lang) || lang}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      }
    >
      <Text>
        {isEnabled ? (
          <Trans>
            <strong>Language</strong> is the display language of all text.
            Please note that no warranty is provided for the accuracy or
            completeness of non-English translations. If you encounter a
            translation error, feel free to make a suggestion on{' '}
            <Link
              variant="external"
              to={
                'https://hosted.weblate.org/projects/actualbudget/actual/' +
                (language ?? '')
              }
              linkColor="purple"
            >
              Weblate
            </Link>
            .
          </Trans>
        ) : (
          <Trans>
            <strong>Language</strong> support is not available. Please follow
            the instructions{' '}
            <Link
              variant="external"
              to="https://actualbudget.org/docs/translations"
            >
              here
            </Link>{' '}
            to add missing translation files.
          </Trans>
        )}
      </Text>
    </Setting>
  );
}
